module.exports = __webpack_public_path__ + "img/badge-exit-confirmation.87162a6f.svg";